var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._v(" © PackShip "+_vm._s(_vm.year)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }